import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [team, setTeam] = useState(null);

  const loadTeam = useCallback(async () => {
    try {
      const { data } = await api.get("/teams/me");
      setTeam(data);
    } catch {
      setTeam(null);
    }
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      await loadTeam();
      return data;
    } catch {
      setUser(false);
      return false;
    }
  }, [loadTeam]);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    setUser(false);
    setTeam(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, team, setTeam, loadTeam, refreshUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
